var meta={showLeftMenu:false,headIndex:1};
export var router = [{
	path: '/alarmStatistics',
	meta:meta,
	name:'alarmStatistics',
	component: resolve => require(["./alarmView.vue"],resolve)
},
{
	path: '/scriptDetail',
	meta:meta,
	name:'scriptDetail',
	component: resolve => require(["./scriptDetail.vue"],resolve)
},
{
	path: '/deviceDetail',
	meta:meta,
	name:'deviceDetail',
	component: resolve => require(["./deviceDetail.vue"],resolve)
}


]


// WEBPACK FOOTER //
// ./src/views/alarmstatistics/router.js